import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { RUN_MODELS } from './constants';
import {
  RunModelsSuccess,
  RunModelsError,
  RunModelsDataActionTypes,
  RunModelsState,
} from './types';

const initialState: RunModelsState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (draft = initialState, action: RunModelsDataActionTypes): RunModelsState => {
    switch (action.type) {
      case RUN_MODELS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case RUN_MODELS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as RunModelsSuccess).payload;
        break;
      }
      case RUN_MODELS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as RunModelsError).error;
        break;
      }
      case RUN_MODELS + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
